import React from "react";

import QueryComponent from "core/api/QueryComponent";
import { IPanelProps, Panel } from "core/decorators/Panel";
import ProgramDetailsConfig from "./config/ProgramDetailsConfig";
import Program from "./entities/Program";
import labelProvider from "./Program.labels";

const { Labels } = labelProvider;

@Panel({
	id: "program-details",
	configClass: ProgramDetailsConfig,
	labelProvider,
	pageParams: true
})
export default class ProgramDetailsPanel extends React.Component<IPanelProps<ProgramDetailsConfig>> {

	public render() {

		return (
			<QueryComponent entity={Program} type="one" args={{}}>
				{
					({data, loading}) => {

						return (
							<div>loading...</div>
						);
					}
				}
			</QueryComponent>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/program/ProgramDetails.panel.tsx